import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { ProfileSettingsConfig } from '@Constants/rx-user/constants';
import { Checkbox } from '@els/els-react--checkbox';
import { Icon } from '@els/els-react--icon';
import { ToggleButton } from '@els/els-react--toggle-button';
import ProfileSettingsAccordionItem from '@Pages/ProfileSettings/Components/ProfileSettingsAccordionItem';

import './SynthesisConditionsPosition.scss';

const { Sprites } = Icon;

const CONDITIONS_DISPLAY_ICON_SPRITES = {
  modal: Sprites.MODAL,
  docked_bottom: Sprites.DOCK_BOTTOM,
  docked_right: Sprites.DOCK_RIGHT,
};

function getConditionsDisplayToggleOptions(conditionsDisplayOptions) {
  return conditionsDisplayOptions.map(({ label, value }) => ({
    iconSprite: CONDITIONS_DISPLAY_ICON_SPRITES[value],
    label,
    value,
  }));
}

function SynthesisConditionsPosition({
  preferences,
  conditionsDisplayOptionTitle,
  conditionsDisplayOptions,
  onChange,
  onSave,
  onClose,
  onReset,
}) {
  const renderValue = () => [
    { title: '', value: conditionsDisplayOptionTitle },
    {
      title: preferences.RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW && ProfileSettingsConfig.Labels.alwaysDisplayConditions,
      value: preferences.RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW && ProfileSettingsConfig.Labels.alwaysDisplayConditions,
    },
  ];

  const conditionsDisplayToggleOptions = getConditionsDisplayToggleOptions(conditionsDisplayOptions);
  const activeConditionsDisplayOption = preferences.RX2_SYNTHESIS_CONDITIONS_POSITION || conditionsDisplayToggleOptions[0]?.value || '';

  return (
    <ProfileSettingsAccordionItem
      onClose={onClose}
      onSave={onSave}
      label={ProfileSettingsConfig.Labels.conditionsDisplayBehavior}
      title={ProfileSettingsConfig.Labels.alwaysShowScreenBeforeCreatingAutoplan}
      value={renderValue()}
      resetButton
      titled
      validateOnSave
      onReset={onReset}
      className="synthesis-conditions-position-accordion-item preferences-accordion-item">
      <div className="preferences-accordion-item__wrapper">
        <div className="synthesis-conditions-position-accordion-item__conditions">
          {conditionsDisplayToggleOptions.length > 0 && (
            <ToggleButton
              activeOption={activeConditionsDisplayOption}
              buttonSize={ToggleButton.ButtonSizes.SMALL}
              buttonStyle={ToggleButton.ButtonStyles.WITH_ICON_AND_LABEL}
              id="synthesis-conditions-position-toggle"
              label={ProfileSettingsConfig.Labels.conditionsDisplayBehavior}
              onClick={(value) => onChange('RX2_SYNTHESIS_CONDITIONS_POSITION', value)}
              options={conditionsDisplayToggleOptions}
              shouldHideLabel
            />
          )}
        </div>
        <div className="preferences-accordion-item__option">
          <div className="preferences-accordion-item__option_label">{ProfileSettingsConfig.Labels.alwaysDisplayConditions}</div>
          <Checkbox
            name="RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW"
            onChange={(event) => onChange('RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW', event?.currentTarget?.checked)}
            checked={!!preferences.RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW}
            id="RX2_SYNTHESIS_CONDITIONS_ALWAYS_SHOW"
            shouldHideLabel
            data-e2e="preferences-always-show-conditions-checkbox"
            label="Toggle to always show synthesis conditions screen before creating an autoplan"
            className="preferences-accordion-item__checkbox"
          />
        </div>
      </div>
    </ProfileSettingsAccordionItem>
  );
}

SynthesisConditionsPosition.propTypes = {
  preferences: PropTypes.object,
  conditionsDisplayOptionTitle: PropTypes.string,
  conditionsDisplayOptions: PropTypes.array,
  onChange: PropTypes.func,
  onSave: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func,
};

SynthesisConditionsPosition.defaultProps = {
  conditionsDisplayOptions: [],
  onChange: noop,
  onSave: noop,
  onClose: noop,
  onReset: noop,
};

export default SynthesisConditionsPosition;
